import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { defineEntity } from '@juvare/platform-app/App';
import { defineColumns } from '@juvare/platform-shared/features/storage';
const followUpAccountMapColumns = defineColumns({
    followUpId: {
        type: 'id-required',
        index: true,
    },
    accountId: {
        type: 'foreign-key',
        entity: accountEntityName,
        onDeleteCascade: true,
    },
    alertId: {
        type: 'id',
        index: true,
    },
});
export const followUpAccountMapEntityName = 'followUpAccountMap';
export const followUpAccountMap = defineEntity({
    version: 1,
    columns: followUpAccountMapColumns,
    onMigrate: (params) => params.oldData,
    /**
     * Nobody can read the data. This entity is used only to filter accounts.
     */
    onAuthGet: () => {
        throw new Error('Unauthorized');
    },
    /**
     * Nobody can read the data. This entity is used only to filter accounts.
     */
    onAuthList: () => {
        throw new Error('Unauthorized');
    },
    /**
     * Only backend code can change data for this entity.
     */
    onAuthPost: () => {
        throw new Error('Unauthorized');
    },
    onTransformColumns: (_context, params) => {
        return {
            followUpId: params.data.followUpId,
            accountId: params.data.accountId,
            alertId: params.data.alertId,
        };
    },
    onMassUpdateTransform: (_context, params) => {
        return {
            alertId: params.data.alertId,
        };
    },
});
export function getFollowUpAccountMapStorage(context) {
    return context.storage(followUpAccountMapEntityName);
}
